<template>
  <div class="scrollBar_wrapper"
    @mousedown="startScroll($event)"
    @touchstart.prevent.stop="startScroll($event)"
    @DOMMouseScroll.prevent.stop="wheelScroll($event)"
    @mousewheel.prevent.stop="wheelScroll($event)"
  >
    <div 
    class="scroller"
    ref="scroller">
      <table ref="pos"
      class="list item-delimiter no-border full-width"
      :style="{'margin-top': scrollShift+'px'}"
      >
        <tr v-if="items.length===0">
          <td style="text-align: center; line-height: 48px;">Aucun résulat</td>
        </tr>
        <template
          v-for="(item, index) in visibleItems">
          <slot
          :keyField="keyField"
          class="item"
          :index="index"
          :item_activated="item_activated"
          :item_selected="item_selected"
          :item="item"></slot>
        </template>
      </table>
    </div>
    <div 
    v-show="has_scroll"
    class="scrollBar_container">
      <div class="scrollBar_wrapper" ref="scrollBar_wrapper">
        <div class="scrollBar"
        @mousedown.prevent.stop="startBarScroll"
        :style="{
        height: scrollBarHeight+'px',
        top: ((scrollTop/scrollMax)*barScrollMax)+'px'
        }">
        </div>
      </div>
    </div>
    <!-- 
    <div
    ref="eventcatcher"
    class="eventcatcher"
    @mousedown.prevent.stop="startScroll($event)"
    @touchstart.prevent.stop="startScroll($event)"
    @DOMMouseScroll.prevent.stop="wheelScroll($event)"
    @mousewheel.prevent.stop="wheelScroll($event)">
    </div> -->
  </div>  
</template>

<script>
'use strict'

var rAF = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (callback) { window.setTimeout(callback, 1000 / 60) }

var getTime = Date.now || function getTime () { return new Date().getTime() }

global.isBadAndroid = false

var appVersion = window.navigator.appVersion
    // Android browser is not a chrome browser.
if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
  var safariVersion = appVersion.match(/Safari\/(\d+.\d)/)

  if (safariVersion && typeof safariVersion === 'object' && safariVersion.length >= 2) {
    global.isBadAndroid = parseFloat(safariVersion[1]) < 535.19
  }
  else {
    global.isBadAndroid = true
  }
}

export default {
  name: 'v-list',
  props: {
    items: {
      required: true
    },
    a: {
      default: -0.002
    },
    animScrollDuration: {
      default: 500
    },
    itemHeight: {
      default: 49
    },
    index: {
      default: 0,
      type: Number
    },
    scrollLen: {
      default: 100
    },
    keyField: {
      default: 'id',
      type: String
    }
  },
  data () {
    return {
      visibleItems: [],
      item_activated: null,
      item_selected: null,
      startIndex: 0,
      scrollTop: 0,
      scrollMax: 0,
      scrollShift: 0,
      barScrollMax: 0,
      has_scroll: false,
      scrollBarHeight: 0,
      item_height: 0
    }
  },

  watch: {
    items: function () { // important
      this.$nextTick(function () {
        this.resize()
      })
    }
  },
  directives: {
    menuResize: {
      update: function (el, directive, vnode) {
        var vm = vnode.context
        vm.$nextTick(function () {
          vm.resize()
        })
      }
    }
  },
  methods: {
    startScroll: function (e) {
      // e.preventDefault()
      // e.stopPropagation()
      // console.log(e)

      global.shouldCloseAll = false

      if (e.touches) {
        e = e.touches[0]
      }

      this.p.scrollPos = e.clientY
      this.p.newScrollPos = this.p.scrollPos
      this.p.scrollTime = getTime()
      // this.p.newScrollTime = 0
      this.p.newScrollTime = this.p.scrollTime
      this.p.scrollDir = 0
      this.p.velocity = 0
      this.has_scrolled = false
      this.p.animating = false
      this.p.scrollAnimating = false

      this.animation.v = 0

      var offset = this.$refs.scroller.getBoundingClientRect()
      var Y = this.p.scrollPos - offset.top - this.scrollShift
      // var Y = e.offsetY - this.scrollShift
      var ind = Math.floor(Y / this.item_height) + this.p.startIndex

      // if (this.item_activated) {
      //   delete this.item_activated.activated
      // }

      this.item_activated = null

      if (typeof this.items[ind] !== 'undefined') {
        this.item_activated = this.items[ind]
        // this.item_activated.activated = true
      }
      window.addEventListener('touchend', this.p.stopScroll_bind)
      window.addEventListener('touchcancel', this.p.stopScroll_bind)
      window.addEventListener('touchleave', this.p.stopScroll_bind)
      window.addEventListener('mouseup', this.p.stopScroll_bind)

      window.addEventListener('touchmove', this.p.scroll_bind)
      // window.addEventListener('mousemove', this.p.scroll_bind)

      this.p.scrollAnimating = true
      this.scrollTranslate()
    },
    onScroll: function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (e.touches) {
        e = e.touches[0]
      }

      this.p.newScrollPos = e.clientY
      this.p.newScrollTime = getTime()
    },
    stopScroll: function (e) {
      if (this.has_scrolled) {
        this.startScrollAnim(e)
      }
      else if (this.item_activated !== null) {
        this.item_selected = this.item_activated
        this.$emit('select', this.item_selected)
      }

      this.item_activated = null

      this.has_scrolled = false
      this.p.scrollAnimating = false

      window.removeEventListener('touchmove', this.p.scroll_bind)
      window.removeEventListener('mousemove', this.p.scroll_bind)
      window.removeEventListener('mouseup', this.p.stopScroll_bind)
      window.removeEventListener('touchend', this.p.stopScroll_bind)
      window.removeEventListener('touchcancel', this.p.stopScroll_bind)
      window.removeEventListener('touchleave', this.p.stopScroll_bind)
    },
    scrollTranslate: function () { // 'scrollTo' en fait
      // global.stats.begin()
      this.p.shift = this.p.newScrollPos - this.p.scrollPos

      if (this.p.newScrollPos !== this.p.scrollPos &&
        (this.has_scrolled || Math.abs(this.p.shift) >= 5)) {
        this.p.scrollPos = this.p.newScrollPos

        this.p.timeDiff = this.p.newScrollTime - this.p.scrollTime
        this.p.scrollTime = this.p.newScrollTime

        if (this.p.timeDiff > 0) {
          if (this.animation.v === 0) {
            this.animation.v = Math.abs(this.p.shift / this.p.timeDiff)
          }
          else {
            this.animation.v = (this.animation.v + Math.abs(this.p.shift / this.p.timeDiff)) / 2
          }
          this.animation.dir = (this.p.shift > 0) ? 1 : -1
        }

        this.applyScroll(this.scrollTop + this.p.shift)
      }
      else if (this.p.velocity > 0) {
        this.p.velocity = Math.max(0, this.p.velocity - this.a * (getTime() - this.p.newScrollTime))
      }

      // global.stats.end()
      if (this.p.scrollAnimating) {
        rAF(this.scrollTranslate)
      }
    },
    startScrollAnim: function (e) {
      this.animation.timeStart = this.p.newScrollTime
      this.p.scrollTime = this.p.newScrollTime // important mais je sais pas où on s'en sert
      this.animation.scrollStart = this.scrollTop
      this.animation.duration = Math.abs(this.animation.v) / -this.a
      this.animation.a = this.a / 2
      this.animation.target = this.animation.dir * this.get_distance(
        this.animation.v,
        this.animation.duration,
        this.animation.a
      )

      if (!this.p.animating) {
        this.p.animating = true
        rAF(this.scrollAnime)
      }
    },
    scrollAnime: function () {
      // global.stats.begin()
      this.p.scrollTimeTmp = getTime()
      this.p.scrollTimeDiff = this.p.scrollTimeTmp - this.animation.timeStart

      if (this.p.animating) {
        if (this.p.scrollTimeDiff >= this.animation.duration) {
          this.p.animating = false
          this.p.scrollShift = this.animation.target
          this.animation.v = 0
          this.animation.target = 0
        }
        else {
          this.p.scrollShift = this.animation.dir * this.get_distance(
            this.animation.v,
            this.p.scrollTimeDiff,
            this.animation.a
          )
        }

        this.applyScroll(this.animation.scrollStart + this.p.scrollShift)
        // global.stats.end()
        rAF(this.scrollAnime)
      }
    },
    wheelScroll: function (e) {
      if (this.p.dirTmp !== this.animation.dir) {
        this.animation.target = 0
      }
      this.p.dirTmp = this.animation.dir
      this.animation.dir = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)))

      this.animation.duration = this.animScrollDuration
      this.animation.timeStart = getTime()
      this.animation.scrollStart = this.scrollTop

      this.animation.target += this.animation.dir * this.scrollLen
      // this.animation.target += this.animation.dir * (this.item_height * 2)
      this.animation.a = -Math.abs(this.animation.target / (Math.pow(this.animation.duration, 2) - 2))
      this.animation.v = 2 * Math.abs(this.animation.a * this.animation.duration)

      if (!this.p.animating) {
        this.p.animating = true
        rAF(this.scrollAnime)
      }
    },
    startBarScroll: function (e) {
      var stopScrollBar = function () {
        window.removeEventListener('mousemove', scrollBar_bind)
        window.removeEventListener('mouseup', stopScrollBar_bind)
      }

      this.animationStartY = this.scrollTop
      this.scrollBarStartY = e.clientY

      var scrollBar_bind = this.barScroll.bind(this)
      var stopScrollBar_bind = stopScrollBar.bind(this)

      window.addEventListener('mousemove', scrollBar_bind, false)
      window.addEventListener('mouseup', stopScrollBar_bind, false)
    },
    barScroll: function (e) {
      var vm = this
      var dist_diff = e.clientY - this.scrollBarStartY
      var shift = (dist_diff / this.barScrollMax) * this.scrollMax
      rAF(function () {
        vm.applyScroll(vm.animationStartY + shift)
      })
    },
    get_distance: function (v, t, a) {
      return Math.round(v * t + a * Math.pow(t, 2))
    },
    applyScroll: function (scrollTop) {
      if (scrollTop < this.scrollMax) {
        scrollTop = this.scrollMax
      }
      else if (scrollTop > 0) {
        scrollTop = 0
      }

      if (scrollTop !== this.scrollTop) {
        this.scrollTop = scrollTop
        this.has_scrolled = true

        this.p.startIndexTmp = Math.floor(-this.scrollTop / this.item_height)

        if (this.p.startIndexTmp !== this.p.startIndex &&
          this.items.length > this.visibleItems.length) {
          this.p.scrollBase = -this.p.startIndexTmp * this.item_height
          // this.p.startIndex = startIndex
          this.setVisibleItems(this.p.startIndexTmp)
        }
        this.scrollShift = this.scrollTop - this.p.scrollBase
        this.$emit('scroll', this.scrollTop)
      }
    },
    initVisibleItems: function () {
      // delete this.visibleItems
      // this.visibleItems = this.items.slice(
      // this.p.startIndex,
      // this.p.startIndex + this.p.itemDisplayed)

      this.visibleItems.splice(
        0,
        this.visibleItems.length,
        ...this.items.slice(
          this.p.startIndex,
          this.p.startIndex + this.p.itemDisplayed
        )
      )
    },
    initVisibleItems3: function () {
      this.visibleItems = []
      for (var i = this.p.startIndex, l = this.p.startIndex + this.p.itemDisplayed; i < l; i++) {
        this.visibleItems.push(i)
      }
    },
    setVisibleItems: function (newStartIndex) {
      this.visibleItems.splice(
        0,
        this.visibleItems.length,
        ...this.items.slice(
          newStartIndex,
          newStartIndex + this.p.itemDisplayed
        )
      )
      this.p.startIndex = newStartIndex
    },
    setVisibleItems4: function (newStartIndex) {
      Array.prototype.splice.apply(
        this.visibleItems,
        [0, this.p.itemDisplayed].concat(
          this.items.slice(
            newStartIndex,
            newStartIndex + this.p.itemDisplayed)
        )
      )
      this.p.startIndex = newStartIndex
    },
    setVisibleItems1: function (newStartIndex) {
      this.p.indexDiff = newStartIndex - this.p.startIndex

      if (this.p.indexDiff > 0) { // scroll downfrom start
        this.p.itemCur = this.p.startIndex + this.p.itemDisplayed
        this.p.itemCurLim = Math.min(this.p.itemCur + this.p.indexDiff, this.items.length)

        while (this.p.itemCur++ < this.p.itemCurLim) {
          this.visibleItems.push(this.items[this.p.itemCur])
          this.visibleItems.splice(0, 1) // remove one element from start
        }
      }
      else if (this.p.indexDiff < 0) { // scroll up
        this.p.itemCur = this.p.startIndex - 1
        this.p.itemCurLim = Math.max(this.p.itemCur + this.p.indexDiff, 0)

        while (this.p.itemCur-- > this.p.itemCurLim) {
          this.visibleItems.unshift(this.items[this.p.itemCur])
          this.visibleItems.splice(-1) // remove one element from end
        }
      }
      this.p.startIndex = newStartIndex
    },
    setVisibleItems2: function (newStartIndex) {
      this.p.itemCurLim = Math.min(
        this.p.itemDisplayed + newStartIndex,
        this.items.length
      )

      for (this.p.itemCur = 0; this.p.itemCur < this.p.itemCurLim; this.p.itemCur++) {
        this.visibleItems[this.p.itemCur] = null
        this.visibleItems[this.p.itemCur] = this.items[newStartIndex + this.p.itemCur]
      }
      this.p.startIndex = newStartIndex
    },
    setVisibleItems3: function (newStartIndex) {
      let lim = Math.min(
        this.p.itemDisplayed + newStartIndex,
        this.items.length
      )

      for (let i = 0; i < lim; i++) {
        this.visibleItems[i] = null
        this.visibleItems[i] = this.items[newStartIndex + i]
      }
      this.p.startIndex = newStartIndex
    },
    resize: function () {
      var vm = this
      // setTimeout(function () {
      var windowHeight = window.outerHeight
      if (!vm.$refs.scroller) return
      let first_tr = vm.$refs.scroller.querySelector('tr:first-child')
      if (first_tr && first_tr.clientHeight > 0) {
        // console.log('first_tr', first_tr, first_tr.clientHeight)
        vm.item_height = first_tr.clientHeight
      }
      vm.p.clientHeight = vm.$refs.scroller.clientHeight
      vm.p.scrollHeight = vm.items.length * vm.item_height
      vm.p.itemDisplayed = Math.min(
        vm.items.length,
        Math.ceil(vm.p.clientHeight / vm.item_height) + 1
      )

      vm.scrollMax = Math.min(0, vm.p.clientHeight - vm.p.scrollHeight + 2)
      vm.has_scroll = (vm.scrollMax < 0)

      var ratio = vm.p.clientHeight / vm.p.scrollHeight
      vm.scrollBarHeight = vm.p.clientHeight * ratio + 15
      vm.barScrollMax = vm.p.clientHeight - vm.scrollBarHeight

      if (vm.index > 0) {
        var startScroll = -vm.index * vm.item_height
        vm.applyScroll(startScroll)
      }

      vm.initVisibleItems()
      // })
    },
    reset: function () {
      this.p.startIndex = 0
      this.scrollTop = 0
      this.p.scrollBase = 0
      this.scrollShift = 0
      this.$set(this, 'visibleItems', [])
      this.resize()
    },
    ScrollToTop: function () {
      this.p.startIndex = 0
      this.scrollTop = 0
      this.p.scrollBase = 0
      this.scrollShift = 0
    }
  },
  beforeDestroy () {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },

  mounted () {
    let vm = this
    this.animation = {
      scrollStart: 0,
      timeStart: getTime(),
      target: 0,
      duration: 0,
      v: 0,
      a: this.a
    }

    this.p = {
      ratio: 0,
      windowHeight: 0,
      startIndexTmp: 0,
      delta: 0,
      indexDiff: 0,
      scrollTime: 0,
      newScrollTime: 0,
      scrollTimeTmp: 0,
      scrollTimeDiff: 0,
      scrollShift: 0,
      scrollTranslateShift: 0,

      itemDisplayed: 40,
      startIndex: 0,

      scrollDir: 0,
      scrollPos: 0,
      newScrollPos: 0,
      velocity: 0,
      scrollHeight: 0,
      clientHeight: 0,
      scrollBase: 0,
      animating: false,
      animationTime: 0,
      animationDuration: 0,
      animationDist: 0,
      scrollAnimating: false,

      stopScroll_bind: this.stopScroll.bind(this),
      scroll_bind: this.onScroll.bind(this)
    }

    if (!global.isBadAndroid) {
      var vendors = [
        '',
        '-webkit-',
        '-moz-',
        '-ms-',
        '-o-'
      ]
      let scroller_el = this.$refs.scroller

      for (var i = 0, l = vendors.length; i < l; i++) {
        scroller_el.style[vendors[i] + 'transform'] = 'translateZ(0)'
      }

      // vendor_list.
      /*-webkit-transform: translateZ(0);
      -moz-transform: translateZ(0);
      -ms-transform: translateZ(0);
      -o-transform: translateZ(0);
      transform: translateZ(0);*/
    }

    // this.p.stopScroll_bind = this.stopScroll.bind(this)
    this.item_height = this.itemHeight
    // }, false)
    this.resize()

    // let resizeTimer = null
    // window.addEventListener('resize', function (e) {
    //   if (resizeTimer) clearTimeout(resizeTimer)
    //   resizeTimer = setTimeout(function () {
    //     console.log('end resize')
    //     vm.resize.bind(vm)
    //   }, 250)
    // }, false)
  }
}
</script>
<style>
.scrollBar_wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  cursor: default;
}

.segment {
  border: 1px solid #ccc;
}

.scrollBar_container {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0px;
  width: 10px;
  padding: 0px;
}

.scrollBar {
  height: 50px;
  background-color: #000;
  opacity: 0.3;
  border-radius: 5px;
  position: absolute;
  z-index: 100;
  padding: 5px 4px;
  cursor: pointer;
}

.scrollBar_wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
/*
.eventcatcher_wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
}*/

.eventcatcher {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
  display: none;
}

.scroller {
  z-index: 1;
  width: 100%;
  height: 100%;
  /*position: absolute;*/
  overflow: hidden;
  -webkit-touch-callout: none;/*
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;*/
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -o-text-size-adjust: none;
  text-size-adjust: none;
}

.scroller item:last-child {
  border-bottom: 0;
}

.menu .eventcatcher {
  z-index: 99;
}

.scroller .list {
  /*position: absolute;*/
  min-width: 100%;
  width: auto;
  table-layout: auto;
}

.scroller .list > .item {
  margin: 0px !important;
  transition: none;
  line-height: 48px;
  width: 100%;
  padding: 0 5px;
}
</style>
